export const URL_BE = process.env.NEXT_PUBLIC_APP_BE_ORIGIN ?? "http://localhost:4000";
